import { render, staticRenderFns } from "./station-baseinfo.vue?vue&type=template&id=686504ff&scoped=true&"
import script from "./station-baseinfo.vue?vue&type=script&lang=js&"
export * from "./station-baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./station-baseinfo.vue?vue&type=style&index=0&id=686504ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686504ff",
  null
  
)

export default component.exports